export const intro = (
  <p>
    <strong>Poradniki Medyczne</strong> to uporządkowane i zgodne z aktualną
    wiedzą źródło informacji o diagnostyce i leczeniu najczęstszych jednostek
    chorobowych w Podstawowej Opiece Zdrowotnej (POZ) i Nocnej Pomocy Lekarskiej
    (NPL). Niezależnie od tego, czy stajesz przed szybkim rozpoznaniem infekcji,
    oceną bólu w klatce piersiowej czy podejmowaniem decyzji terapeutycznych,
    znajdziesz tu praktyczne wskazówki oparte na najnowszych wytycznych. Sekcja
    ta została stworzona z myślą o lekarzach, studentach i wszystkich
    profesjonalistach ochrony zdrowia, którzy chcą działać skutecznie i w
    oparciu o aktualną wiedzę.
  </p>
);

export const content = (
  <>
    <p>
      W codziennej praktyce lekarze POZ i NPL muszą błyskawicznie podejmować
      decyzje diagnostyczne i terapeutyczne. Sekcja{" "}
      <strong>Poradniki Medyczne</strong> dostarcza sprawdzonych i przejrzystych
      informacji, które pomagają w efektywnej pracy klinicznej. Publikowane
      materiały obejmują szeroki zakres tematów – od ostrych infekcji, przez
      choroby przewlekłe, po profilaktykę i standardy postępowania w
      najczęstszych stanach nagłych.
    </p>

    <p>
      Każdy poradnik to nie tylko teoria, ale również gotowe algorytmy
      postępowania i praktyczne wskazówki ułatwiające podjęcie trafnych decyzji
      medycznych. Przedstawiamy zarówno podstawowe zasady diagnostyki, jak i
      najnowsze rekomendacje dotyczące farmakoterapii oraz postępowania
      niefarmakologicznego. Omawiamy również najnowsze zmiany w przepisach,
      które mogą mieć wpływ na codzienną praktykę lekarską. Dzięki temu lekarze
      mogą pracować sprawniej i skuteczniej, zapewniając pacjentom najlepszą
      możliwą opiekę.
    </p>

    <p>
      Oprócz omówień przypadków klinicznych i algorytmów postępowania, sekcja ta
      zawiera przystępne analizy badań naukowych i wytycznych międzynarodowych
      towarzystw medycznych. Poruszamy również kwestie związane z profilaktyką
      zdrowotną oraz wskazówki dotyczące optymalizacji codziennej pracy lekarza
      – zarówno w zakresie efektywnej organizacji wizyt, jak i komunikacji z
      pacjentami. Dzięki temu <strong>Poradniki Medyczne</strong> to nie tylko
      źródło wiedzy, ale również narzędzie wspierające praktykę lekarską w
      dynamicznie zmieniających się realiach ochrony zdrowia.
    </p>

    <h3>Dlaczego warto korzystać z sekcji Poradniki Medyczne?</h3>
    <p>
      Sekcja <strong>Poradniki Medyczne</strong> to wszechstronne źródło
      informacji, które pozwala lekarzom podejmować lepsze decyzje kliniczne.
      Znajdziesz tutaj:
    </p>
    <ul>
      <li>
        <strong>aktualną wiedzę</strong> – wszystkie informacje są zgodne z
        najnowszymi wytycznymi i standardami medycznymi, co gwarantuje ich
        rzetelność i przydatność w praktyce klinicznej;
      </li>
      <li>
        <strong>praktyczne podejście</strong> – dostarczamy konkretne zalecenia
        dotyczące diagnostyki i terapii, które można bezpośrednio zastosować w
        codziennej pracy z pacjentem;
      </li>
      <li>
        <strong>szeroki zakres tematów</strong> – od diagnostyki i leczenia po
        profilaktykę i organizację pracy lekarza;
      </li>
      <li>
        <strong>łatwy dostęp do kluczowych informacji</strong> – szybka pomoc w
        podejmowaniu decyzji medycznych, dostępna w każdej chwili.
      </li>
    </ul>

    <h3>Rozwijaj swoje kompetencje i podejmuj trafne decyzje!</h3>
    <p>
      Sekcja <strong>Poradniki Medyczne</strong> to niezastąpione narzędzie dla
      lekarzy pracujących w POZ i NPL. Regularnie aktualizujemy treści, aby
      dostarczać rzetelne i praktyczne informacje wspierające codzienną pracę
      kliniczną. Śledź nasze materiały, aby być na bieżąco z najnowszymi
      wytycznymi, poprawiać jakość świadczonej opieki i podejmować najlepsze
      możliwe decyzje terapeutyczne.
    </p>
  </>
);

export const tutorialDescription = { intro, content };
